// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aushN64oIFkRHZoueEPJ7 {\n    color: #333;\n    cursor: pointer;\n    font-family: monospace;\n    font-size: 12px;\n    overflow: hidden;\n    padding: 8px;\n    text-overflow: ellipsis;\n    user-select: none;\n    white-space: nowrap;\n    width: 260px;\n}\n\n._1ImXMYY4uxaXivnPgGDI_ {\n    cursor: default;\n}\n", ""]);
// Exports
exports.locals = {
	"value": "aushN64oIFkRHZoueEPJ7",
	"only": "_1ImXMYY4uxaXivnPgGDI_"
};
module.exports = exports;
